import { render } from "./AppRightMenu.vue?vue&type=template&id=2f9b1a27"
import script from "./AppRightMenu.vue?vue&type=script&lang=js"
export * from "./AppRightMenu.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__